import React from 'react'
import { useSelector } from 'react-redux';
function AboutusContainer({ layout }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);


    return (
        <section className='contact_container'>
            <div className='contact_box'>
                <h5 className='text-center fw-bold mb-3'>{currentLocal.home.aboutus}</h5>
{currentLocal && currentLocal.language === "English" ?
<p>

Since our launch in 2018, we began our passion journey in the world of cosmetics with the Heaven Smile brand, setting one goal before us: to provide high-quality products that meet our customers' needs and gain their trust.
The idea started from a friendship before it was a business, bringing together the dream. ambition, and desire to make a difference in the market. By the grace of God, we achieved remarkable successes in a short time, and one of our products became a prominent and trending name in the Egyptian market.
Today, we continue to work with the same team spirit and passion with which we started to always offer our customers the best.</p>
:
<div>
<p>
    منذ انطلاقنا في عام 2018، بدأنا رحلة شغفنا في عالم مستحضرات التجميل مع علامة هيڤين سمايل، واضعين أمامنا هدفًا واحدًا: تقديم منتجات عالية الجودة تلبي احتياجات عملائنا وتكسب تقتهم
</p>
<p>
    انطلقت الفكرة من شراكة مداقة قبل أن تكون عمل، وجمعنا الحلم والطموح والرغبة في صنع فارق في السوق. بفضل الله، حققنا في وقت قصير نجاحات لافتة، واصبح احد منتجاتنا من العلامات البارزة والترند في السوق المصري
</p>
<p>
    اليوم، نستمر في العمل بروج الفريق والشغف نفسه الذي بدانا به، لنقدّم لعملائنا الافضل دائفا
</p>
</div>

}
            </div>
        </section>)
}

export default AboutusContainer